import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import TawkToWidget from "./components/TawkToWidget";
import WhatsAppButton from "./components/WhatsAppButton";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import BookingForm from "./pages/BookingForm";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import DailyTrackerView from "./pages/DailyTrackerView";
import DriverDashboard from "./pages/DriverDashboard";
import TrackRide from "./pages/TrackRide";
import FareCalculator from "./pages/FareCalculator";
import Flights from "./pages/Flights";
import TripCompletionForm from "./pages/TripCompletionForm";
import ReceiptPage from "./pages/ReceiptPage";
import ReviewPage from "./pages/ReviewPage";
import ReviewsManagement from "./pages/ReviewsManagement";
import PublicReviews from "./pages/PublicReviews";
import LogoDownload from "./pages/LogoDownload";
import DriverTracking from "./pages/DriverTracking";
import SunMedBooking from "./pages/SunMedBooking";
import Premier from "./pages/Premier";
import Services from "./pages/Services";
import NassauAirportTransfers from "./pages/NassauAirportTransfers";
import LpiaToAtlantis from "./pages/LpiaToAtlantis";
import LpiaToBahaMar from "./pages/LpiaToBahaMar";
import CruisePortTransportation from "./pages/CruisePortTransportation";
import HeyTaxi from "./pages/HeyTaxi";
import HeyTaxiPost from "./pages/HeyTaxiPost";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/book" element={<BookingForm />} />
              <Route path="/sun-med-booking" element={<SunMedBooking />} />
              <Route path="/premier" element={<Premier />} />
              <Route path="/services" element={<Services />} />
              <Route path="/nassau-airport-transfers" element={<NassauAirportTransfers />} />
              <Route path="/lpia-to-atlantis" element={<LpiaToAtlantis />} />
              <Route path="/lpia-to-baha-mar" element={<LpiaToBahaMar />} />
              <Route path="/cruise-port-transportation" element={<CruisePortTransportation />} />
              <Route path="/hey-taxi" element={<HeyTaxi />} />
              <Route path="/hey-taxi/:slug" element={<HeyTaxiPost />} />
              <Route path="/flights" element={<Flights />} />
              <Route path="/fare-calculator" element={<FareCalculator />} />
              <Route path="/login" element={<Login />} />
              <Route path="/reviews" element={<PublicReviews />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/daily/:date"
                element={
                  <ProtectedRoute>
                    <DailyTrackerView />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/complete-trip"
                element={
                  <ProtectedRoute>
                    <TripCompletionForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/reviews"
                element={
                  <ProtectedRoute>
                    <ReviewsManagement />
                  </ProtectedRoute>
                }
              />
              <Route path="/driver-dashboard" element={<DriverDashboard />} />
              <Route path="/driver-tracking" element={<DriverTracking />} />
              <Route path="/download-logo" element={<LogoDownload />} />
              <Route path="/receipt/:bookingNumber" element={<ReceiptPage />} />
              <Route path="/review/:bookingNumber" element={<ReviewPage />} />
              <Route path="/track/:bookingId" element={<TrackRide />} />
            </Routes>
            <Footer />
            <WhatsAppButton />
            <TawkToWidget />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
